import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { WorkspaceBreadcrumb } from './workspace-breadcrumbs.component';

/**
 * Crumbs a routed page appends after its route-derived Workspace breadcrumbs,
 * for locations the route config cannot name (for example a Files folder path).
 * The page that sets a trail clears it when it is destroyed.
 */
@Injectable({ providedIn: 'root' })
export class WorkspaceBreadcrumbTrail {
  private readonly trail = new BehaviorSubject<WorkspaceBreadcrumb[]>([]);
  readonly trail$ = this.trail.asObservable();
  set(crumbs: WorkspaceBreadcrumb[]): void { this.trail.next(crumbs); }
  clear(): void { this.trail.next([]); }
}
